/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import { useRef } from 'react'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import { Lightbox } from '@nexigendigital/nxui'

import BillingCycleForm from 'containers/services/form/billingCycleForm'
import { FormikProps } from 'formik'

/**********************************************************************************************************
 *   INTERFACE
 **********************************************************************************************************/
interface Props {
    id: number,
    status: boolean,
    close: () => void
}

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export default function BillingCycleLightbox({ id, status, close }: Props) {
    const formRef = useRef<FormikProps<{ billing_cycle_id: number }>>(null)

    /*   RENDER COMPONENT
    **********************************************************************************************************/
    return (
        <Lightbox
            title={'Change Billing Cycle'}
            description={
                `You can change your billing cycle to make when you're invoiced more convenient. 
                You will be invoiced on the new billing cycle at the end of your current prepaid period.`
            }
            content={<BillingCycleForm id={id} form={formRef} close={close}/>}
            conditions={{ state: status, action: () => close() }}
            links={[]}
            actions={[
                {
                    label: 'Back',
                    color: 'secondary',
                    func: () => close()
                },
                {
                    label: 'Change',
                    color: 'primary',
                    type: 'submit',
                    loading: formRef?.current?.isSubmitting ? 'Changing' : false,
                    form: 'changeBillingCycleForm'
                }
            ]}
        />
    )
}
